import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryMetadata } from '../models/country-metadata';
import { Observable } from 'rxjs';
import { UIViewOption } from '../models/common-data-types';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private baseUrl: string = '/metadata/countries';

  constructor(private httpClient: HttpClient) { }

  getCountryMetadata(): Observable<CountryMetadata[]> {
    return this.httpClient.get<CountryMetadata[]>(this.baseUrl)
  }

  getIdentificationTypes(): Observable<UIViewOption[]> {
    return this.httpClient.get<UIViewOption[]>('/selfcare/identification-types')
  }

  getCountryProvinces(countryId: string): Observable<any>{
    return this.httpClient.get<any>(`${this.baseUrl}/${countryId}/provinces`);
  }
}
